import _ from "lodash";
import Grid from "@mui/material/Grid";
import SoftBox from "components/SoftBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import UserUpdateForm from "components/CustomForms/UserUpdateForm";
import UserUpdatePassForm from "components/CustomForms/UserUpdatePassForm";

function UsersModify() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox mt={3} mb={4}>
        <Grid container spacing={3} justifyContent="center">
          <UserUpdateForm />
          <UserUpdatePassForm />
        </Grid>
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default UsersModify;
